module.exports = __webpack_public_path__ + "img/KIR.6dc2424d.gif";